customElements.get("product-form") ||
  customElements.define(
    "product-form",
    class extends HTMLElement {
      constructor() {
        (super(), (this.originalButtonText = ""), (this.persistentTextActive = !1));
      }
      isSoldOut() {
        return this.submitButton && this.submitButton.classList.contains("sold-out");
      }
      getBaseLabel() {
        return this.submitButton
          ? this.submitButton.dataset.baseLabel ||
              this.submitButton.dataset.persistentText ||
              this.submitButton.dataset.originalText ||
              (window.variantStrings && window.variantStrings.addToCart) ||
              "Add to cart"
          : (window.variantStrings && window.variantStrings.addToCart) || "Add to cart";
      }
      getSoldOutLabel() {
        return this.submitButton
          ? this.submitButton.dataset.soldOutLabel ||
              (window.variantStrings && window.variantStrings.soldOut) ||
              "Sold out"
          : (window.variantStrings && window.variantStrings.soldOut) || "Sold out";
      }
      hasBaseLabel() {
        return !!(
          this.submitButton &&
          (this.submitButton.dataset.baseLabel ||
            this.submitButton.dataset.persistentText ||
            "true" === this.submitButton.dataset.textOverride ||
            this.submitButton.classList.contains("has-persistent-text"))
        );
      }
      restoreBaseLabel() {
        if (!this.submitButtonText || this.isSoldOut()) return;
        const t = this.getBaseLabel();
        if (!t) return;
        const e = "true" === this.submitButton.dataset.showPrice;
        const i = this.submitButtonText.textContent.trim();
        if (e) {
          if (!i.startsWith(t.trim())) {
            this.submitButtonText.textContent = t;
            this.triggerRefreshButtonPrice();
          }
        } else if (i !== t) this.submitButtonText.textContent = t;
      }
      triggerRefreshButtonPrice() {
        if (this.submitButton && "true" === this.submitButton.dataset.showPrice) {
          document.dispatchEvent(new CustomEvent("product-form:refresh-button-price"));
        }
      }
      connectedCallback() {
        setTimeout(() => {
          if (((this.form = this.querySelector("form")), !this.form)) return;
          const t = this.variantIdInput;
          if (
            (t && (t.disabled = !1),
            this.form.addEventListener("submit", this.onSubmitHandler.bind(this)),
            (this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer")),
            (this.submitButton = this.querySelector('[type="submit"]')),
            this.submitButton)
          ) {
            if (
              ((this.submitButtonText = this.submitButton.querySelector(".button-text")),
              this.submitButtonText &&
                ((this.originalButtonText = this.submitButtonText.textContent),
                (this.submitButton.dataset.originalText = this.originalButtonText)),
              this.hasBaseLabel() && this.submitButtonText)
            ) {
              this.persistentTextActive = !0;
              this.restoreBaseLabel();
            }
            (this.persistentTextActive && this.submitButtonText && this.setupButtonTextObserver(),
              document.querySelector("cart-drawer") && this.submitButton.setAttribute("aria-haspopup", "dialog"),
              (this.hideErrors = "true" === this.dataset.hideErrors),
              document.addEventListener("variant:change", this.handleVariantChange.bind(this)));
            // QA fix: after any failed add (e.g. one shade or a free gift out of stock) the
            // button was flipped to "Sold out" and stayed disabled even after the shopper picked
            // another shade/deal, because the Quantity Break picker never re-renders the form.
            // Clear that error state whenever the selection changes.
            this.resetErrorState = this.resetErrorState || (() => {
              if (!this.error) return;
              this.error = !1;
              this.submitButton.removeAttribute("aria-disabled");
              const so = this.submitButton.querySelector(".sold-out-message");
              so && so.classList.add("hidden");
              this.submitButtonText && this.submitButtonText.classList.remove("hidden");
              this.handleErrorMessage();
            });
            document.addEventListener("quantity_break:changed", this.resetErrorState);
          }
        }, 100);
      }
      setupButtonTextObserver() {
        if (!this.submitButtonText) return;
        const t = { characterData: !0, childList: !0, subtree: !0 };
        if (this.persistentTextActive) {
          const e = this.getBaseLabel();
          if (!e) return;
          const showPrice = "true" === this.submitButton.dataset.showPrice;
          ((this.buttonTextObserver = new MutationObserver((t) => {
            if (this.isSoldOut()) return;
            const currentText = this.submitButtonText.textContent.trim();
            const persistentText = e.trim();
            if (showPrice) {
              // price-sync.js owns all price DOM updates.
              // Only guard the label prefix; never fire refresh-button-price here
              // to avoid the "reset label → re-add price" flash cycle.
              if (!currentText.startsWith(persistentText)) {
                this.submitButtonText.textContent = e;
              }
            } else {
              if (currentText !== persistentText) {
                this.submitButtonText.textContent = e;
              }
            }
          })),
            this.buttonTextObserver.observe(this.submitButtonText, t));
        }
      }
      handleVariantChange(t) {
        this.submitButtonText &&
          setTimeout(() => {
            if (this.isSoldOut()) return;
            if (this.persistentTextActive) {
              const showPrice = "true" === this.submitButton.dataset.showPrice;
              if (!showPrice) {
                this.restoreBaseLabel();
              }
            }
          }, 50);
      }
      ensureSellingPlanValue() {
        let planIdToUse = null;
        try {
          const sellingPlanInput = this.form.querySelector('input[name="selling_plan"]');
          if (sellingPlanInput) {
            if (sellingPlanInput.value) {
              planIdToUse = sellingPlanInput.value;
            } else {
              const subscribeToggle = document.querySelector(
                '.subscribe-save-wrapper input[type="checkbox"]:checked, .subscribe-save-wrapper-dynamic input[type="checkbox"]:checked',
              );
              if (subscribeToggle) {
                const wrapper = subscribeToggle.closest(".subscribe-save-wrapper, .subscribe-save-wrapper-dynamic");
                if (wrapper) {
                  planIdToUse = wrapper.dataset.sellingPlanId || subscribeToggle.dataset.planId;
                }

                if (planIdToUse) {
                  sellingPlanInput.value = planIdToUse;
                  sellingPlanInput.setAttribute("value", planIdToUse);
                }
              }
            }
          }
        } catch (error) {
          console.warn("⚠️ product-form.js: Error setting selling_plan:", error);
        }
        return planIdToUse;
      }
      onSubmitHandler(t) {
        if ((t.preventDefault(), "true" === this.submitButton.getAttribute("aria-disabled"))) return;
        (this.handleErrorMessage(),
          this.submitButton.setAttribute("aria-disabled", !0),
          this.submitButton.classList.add("loading"),
          this.querySelector(".loading__spinner").classList.remove("hidden"));

        const e = fetchConfig("javascript");
        ((e.headers["X-Requested-With"] = "XMLHttpRequest"), delete e.headers["Content-Type"]);

        const planIdToUse = this.ensureSellingPlanValue();

        const s = new FormData(this.form);

        if (this.cart) {
          this.cart.openDrawer = true;
        }

        // Check if premium-attachment-kit has already added items[] inputs to the form
        const hasItemsInputs = this.form.querySelector('input[name^="items["]') !== null;

        if (hasItemsInputs) {
          // Premium-attachment-kit has added items[] inputs - use FormData directly

          (this.cart &&
            (s.append(
              "sections",
              this.cart.getSectionsToRender().map((t) => t.id),
            ),
            s.append("sections_url", window.location.pathname),
            this.cart.setActiveElement(document.activeElement)),
            (e.body = s),
            fetch(`${routes.cart_add_url}`, e)
              .then((t) => t.json())
              .then(this.handleCartResponse.bind(this, s, t))
              .catch((t) => {
                console.error(t);
              })
              .finally(this.handleSubmitFinally.bind(this, t)));
        } else {
          // Original behavior: single product with FormData
          (this.cart &&
            (s.append(
              "sections",
              this.cart.getSectionsToRender().map((t) => t.id),
            ),
            s.append("sections_url", window.location.pathname),
            this.cart.setActiveElement(document.activeElement)),
            (e.body = s),
            fetch(`${routes.cart_add_url}`, e)
              .then((t) => t.json())
              .then(this.handleCartResponse.bind(this, s, t))
              .catch((t) => {
                console.error(t);
              })
              .finally(this.handleSubmitFinally.bind(this, t)));
        }
      }
      handleCartResponse(formData, event, responseData) {
        if (responseData.status) {
          (publish(PUB_SUB_EVENTS.cartError, {
            source: "product-form",
            productVariantId: formData.get("id"),
            errors: responseData.errors || responseData.description,
            message: responseData.message,
          }),
            this.handleErrorMessage(responseData.description));
          const e = this.submitButton.querySelector(".sold-out-message");
          if (!e) return;
          return (
            this.submitButton.setAttribute("aria-disabled", !0),
            this.submitButtonText.classList.add("hidden"),
            e.classList.remove("hidden"),
            void (this.error = !0)
          );
        }
        if (this.submitButton && this.submitButton.dataset.behavior === "skip_to_checkout") {
          window.location.href = "/checkout";
          return;
        }
        if (!this.cart) return void (window.location = window.routes.cart_url);
        const e = CartPerformance.createStartingMarker("add:wait-for-subscribers");
        (this.error ||
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "product-form",
            productVariantId: formData.get("id"),
            cartData: responseData,
          }).then(() => {
            CartPerformance.measureFromMarker("add:wait-for-subscribers", e);
          }),
          (this.error = !1));
        const i = this.closest("quick-add-modal");
        i
          ? (document.body.addEventListener(
              "modalClosed",
              () => {
                setTimeout(() => {
                  CartPerformance.measure("add:paint-updated-sections", () => {
                    this.cart.renderContents(responseData);
                  });
                });
              },
              { once: !0 },
            ),
            i.hide(!0))
          : CartPerformance.measure("add:paint-updated-sections", () => {
              this.cart.renderContents(responseData);
            });
      }
      handleSubmitFinally(event) {
        (this.submitButton.classList.remove("loading"),
          this.cart && this.cart.classList.contains("is-empty") && this.cart.classList.remove("is-empty"),
          this.error || this.submitButton.removeAttribute("aria-disabled"),
          this.querySelector(".loading__spinner").classList.add("hidden"));
        if (!this.error && this.persistentTextActive && !this.isSoldOut()) {
          this.restoreBaseLabel();
        }
        CartPerformance.measureFromEvent("add:user-action", event);
      }
      handleErrorMessage(t = !1) {
        this.hideErrors ||
          ((this.errorMessageWrapper =
            this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper")),
          this.errorMessageWrapper &&
            ((this.errorMessage =
              this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message")),
            this.errorMessageWrapper.toggleAttribute("hidden", !t),
            t && (this.errorMessage.textContent = t)));
      }
      toggleSubmitButton(t = !0, e) {
        if (
          (t &&
            (this.submitButton.setAttribute("disabled", "disabled"),
            e && this.submitButtonText && (this.submitButtonText.textContent = e),
            e && this.submitButton.classList.toggle("sold-out", e === this.getSoldOutLabel())),
          !t)
        ) {
          this.submitButton.removeAttribute("disabled");
          this.submitButton.classList.remove("sold-out");
          if (this.persistentTextActive) {
            this.restoreBaseLabel();
            return;
          }
        } else {
          this.originalButtonText
            ? (this.submitButtonText.textContent = this.originalButtonText)
            : this.submitButton.dataset.originalText
              ? (this.submitButtonText.textContent = this.submitButton.dataset.originalText)
              : (this.submitButtonText.textContent = window.variantStrings.addToCart);
        }
      }
      disconnectedCallback() {
        (this.buttonTextObserver && this.buttonTextObserver.disconnect(),
          document.removeEventListener("variant:change", this.handleVariantChange));
      }
      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    },
  );
